import styled from 'styled-components'
import { ReactElement } from 'react'
import { IIconProps } from './types'

const Svg = styled.svg`
  width: '12px';
  height: '18px';
  fill: #423f9a;
`

export const CheckedLuggageIcon = ({ className }: IIconProps): ReactElement => {
  return (
    <Svg
      className={className}
      width="12"
      height="18"
      viewBox="0 0 12 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.1667 4.00033H8.50008V1.50033C8.50008 1.04199 8.12508 0.666992 7.66675 0.666992H4.33342C3.87508 0.666992 3.50008 1.04199 3.50008 1.50033V4.00033H1.83341C0.916748 4.00033 0.166748 4.75033 0.166748 5.66699V14.8337C0.166748 15.7503 0.916748 16.5003 1.83341 16.5003C1.83341 16.9587 2.20841 17.3337 2.66675 17.3337C3.12508 17.3337 3.50008 16.9587 3.50008 16.5003H8.50008C8.50008 16.9587 8.87508 17.3337 9.33342 17.3337C9.79175 17.3337 10.1667 16.9587 10.1667 16.5003C11.0834 16.5003 11.8334 15.7503 11.8334 14.8337V5.66699C11.8334 4.75033 11.0834 4.00033 10.1667 4.00033ZM3.29175 14.0003C2.95008 14.0003 2.66675 13.717 2.66675 13.3753V7.12533C2.66675 6.78366 2.95008 6.50033 3.29175 6.50033C3.63341 6.50033 3.91675 6.78366 3.91675 7.12533V13.3753C3.91675 13.717 3.63341 14.0003 3.29175 14.0003ZM6.00008 14.0003C5.65841 14.0003 5.37508 13.717 5.37508 13.3753V7.12533C5.37508 6.78366 5.65841 6.50033 6.00008 6.50033C6.34175 6.50033 6.62508 6.78366 6.62508 7.12533V13.3753C6.62508 13.717 6.34175 14.0003 6.00008 14.0003ZM7.25008 4.00033H4.75008V1.91699H7.25008V4.00033ZM8.70842 14.0003C8.36675 14.0003 8.08342 13.717 8.08342 13.3753V7.12533C8.08342 6.78366 8.36675 6.50033 8.70842 6.50033C9.05008 6.50033 9.33342 6.78366 9.33342 7.12533V13.3753C9.33342 13.717 9.05008 14.0003 8.70842 14.0003Z"
        fill="#5D5C70"
      />
    </Svg>
  )
}
